// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__cxHlU","col":"Table_col__-g2rI","fulfillmentStatus":"Table_fulfillmentStatus__1sO0U","emailCol":"Table_emailCol__1huzN"};